export enum StoreElement {
    Actions = 'actions',
    AlarmCategories = 'alarmCategories',
    Alarms = 'alarms',
    AlarmEmails = 'alarmEmails',
    AlarmTemplates = 'alarmTemplates',
    ApiInformation = 'apiInformation',
    Application = 'application',
    ApprovalSettings = 'approvalSettings',
    ApprovalStrategies = 'approvalStrategies',
    Authentication = 'authentication',
    Categories = 'categories',
    ConnectionPoints = 'connectionPoints',
    ConnectionPointsStatuses = 'connectionPointsStatuses',
    Dashboards = 'dashboards',
    DashboarUsers = 'dashboardUsers',
    DigitalSets = 'digitalSets',
    DigitalCorrespondanceTables = 'digitalCorrespondanceTables',
    GlobalNotifications = 'globalNotifications',
    Groups = 'groups',
    HistorianStorageConfigurations = 'historianStorageConfigurations',
    Identifiers = 'identifiers',
    Layout = 'layout',
    MailingJobs = 'mailingJobs',
    ObjectAccessRights = 'objectAccessRights',
    UserGroups = 'userGroups',
    OnlineUsers = 'onlineUsers',
    // SelectedGroup  = 'selectedGroup', // cannot be loaded, should not be in store
    States = 'states',
    Tags = 'tags',
    TagsDto = 'tagsDto',
    Tasks = 'tasks',
    Templates = 'templates',
    Tickets = 'tickets',
    TicketStatuses = 'ticketStatuses',
    TicketTypes = 'ticketTypes',
    Triggers = 'triggers',
    TriggerActions = 'triggerActions',
    ValueViewModels = 'valueViewModels',
    ValidationPageConfigurations = 'validationPageConfigurations',
    Variables = 'variables',
    Users = 'users'
}

export enum NonLoadableStoreElements {
    SelectedGroup = 'selectedGroup', // cannot be loaded, should not be in store
}